import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
    noop = () => {};
    log(...args: any[]): void { !environment.production ? console.log(...args)  : this.noop() }
    warn(...args: any[]): void { !environment.production ? console.warn(...args) : this.noop() }
    error(...args: any[]): void { !environment.production ? console.error(...args): this.noop() }
}
